<div class="date-range-filter" [formGroup]="form">
    <mat-form-field appearance="outline">
        <mat-label>Data inizio</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" [max]="form.get('endDate')?.value" class="datepicker-filter" (dateChange)="changeDate()" readonly (click)="startPicker.open()">
        <button *ngIf="form.get('startDate')?.value" mat-icon-button matSuffix type="button" aria-label="Cancella data inizio" (click)="clearStartDate()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Data fine</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="form.get('startDate')?.value" class="datepicker-filter" (dateChange)="changeDate()" readonly (click)="endPicker.open()">
        <button *ngIf="form.get('endDate')?.value" mat-icon-button matSuffix type="button" aria-label="Cancella data fine" (click)="clearEndDate()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <mat-error *ngIf="form.hasError('dateRangeInvalid')">
        La data di inizio non può essere successiva alla data di fine
    </mat-error>

</div>
